import type { JSX } from "react";
import type { AuthStatus } from "../types";
import { LoadingStateScreen } from "./LoadingStateScreen";

export interface AuthScreenProps {
  status: AuthStatus;
  message: string;
}

export function AuthScreen({ status, message }: AuthScreenProps): JSX.Element {
  return (
    <LoadingStateScreen
      stateAttribute="data-platform-auth-state"
      authStatus={status}
      showProgress={status !== "error"}
      title="Authenticating…"
      message={message}
    />
  );
}
